import {createClient} from '@sanity/client';
import {createImageUrlBuilder} from '@sanity/image-url';

// Configure Sanity client
export const client = createClient({
    projectId: '4uevcyut',
    dataset: 'production',
    apiVersion: '2024-01-01',
    useCdn: true,
});

// Create image URL builder instance
const builder = createImageUrlBuilder(client);

// Helper function to generate optimized image URLs from Sanity image references
export function urlFor(source) {
    return builder.image(source);
}
